export default {
  mini: JSON.parse(localStorage.getItem("so_mini")) || false, // boolean -- состояние меню
  startDate: null, // string (YYYY-MM-DD) -- дата начала деятельности
  curDate: null, // string (YYYY-MM-DD) -- текущая дата
  dateFrom: "", // string (YYYY-MM-DD) -- дата начала периода
  dateTo: "", // string (YYYY-MM-DD) -- дата конца периода
  pult: "", // string -- выбранный пользователем пульт (может отсутствовать для пользователей без привязанного кассира)
  user: null,
  agent: null,
  roles: null,
  cashier: null,
  group: null,
  snack: null,
  dialog: null,
  dialogStatus: null,
  blank: false,
  order: false,
  gridFilterOn: false,
  externalFilterDialog: false,
  filteredColumns: null,
  periodClients: null,
  filteredClients: null,
  selectedClients: null,
  searchValue: {},
  filteredData: {},
  loading: false,
  orderParams: "",
  blankParams: "new",
  servicesList: null,
  fopList: null,
  commonBarScreenParseDialog: false,
  documentsAssignCashierDialog: false,
  cashierList: null,
  documentsList: null,
  documentsDeep: null,
  payCodes: null,
  payTypes: null,
  rowData: {},
  mainMenu: null,
  settingsMenu: [
    {
      icon: "exit",
      link: 3,
      module: null,
      modules: null,
      rightModule: "",
      text: "Выход",
    },
  ],
  insurance: false,
  insuranceParams: null,
  tokenForOld: null,
  gridFilters: {},
  currentGrid: null,
  dailyReports: null,
  parsersList: null,
  reportNewVersionAccess: null,
  columnsOnGrid: {},
  reportsAdditionalList: null,
  additionalTableTemplates: [],
  currentAdditionalReport: null,
  additionalReportData: null,
};
